import { render, staticRenderFns } from "./FileAttachementItems.vue?vue&type=template&id=65aa0a4a&scoped=true&"
import script from "./FileAttachementItems.vue?vue&type=script&lang=js&"
export * from "./FileAttachementItems.vue?vue&type=script&lang=js&"
import style0 from "./FileAttachementItems.vue?vue&type=style&index=0&id=65aa0a4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65aa0a4a",
  null
  
)

export default component.exports